module.exports = __webpack_public_path__ + "static/media/program-learn-main-2.055659e9.png";